/**
 * Returns a typed proxy that maps property names to their string keys.
 * Use to get a type-safe property name string without hardcoding it.
 *
 * @example
 * nameOf<AppClaims>().serverReferenceDataRefresh
 * // returns: "serverReferenceDataRefresh"
 */
export function nameOf<T>() {
  return _nameProxy as unknown as { [P in keyof T]: P };
}

const _nameProxy = new Proxy({}, { get(_target, key) { return key; } });
